"use strict";

var _regeneratorRuntime = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var RootProvider = /*#__PURE__*/function () {
  function RootProvider() {
    _classCallCheck(this, RootProvider);

    this.extensions = [];
  }

  _createClass(RootProvider, [{
    key: "addExtension",
    value: function addExtension() {
      var _this$extensions;

      (_this$extensions = this.extensions).push.apply(_this$extensions, arguments);

      return this;
    }
  }, {
    key: "addExtensions",
    value: function addExtensions() {
      return this.addExtension.apply(this, arguments);
    }
  }, {
    key: "removeExtension",
    value: function removeExtension() {
      for (var _len = arguments.length, extensions = new Array(_len), _key = 0; _key < _len; _key++) {
        extensions[_key] = arguments[_key];
      }

      this.extensions = this.extensions.filter(function (extension) {
        return !extensions.includes(extension);
      });
      return this;
    }
  }, {
    key: "removeExtensions",
    value: function removeExtensions() {
      return this.removeExtension.apply(this, arguments);
    }
  }, {
    key: "send",
    value: function send(request, callback) {
      var _this = this;

      if (!this.extensions.length) {
        this.innerProvider.send(request, callback);
        return;
      }

      (function () {
        return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var result, jsonrpc, id, method, params, _iterator, _step, extension;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  result = null;
                  jsonrpc = request.jsonrpc, id = request.id, method = request.method, params = request.params;
                  _iterator = _createForOfIteratorHelper(this.extensions);
                  _context.prev = 4;

                  _iterator.s();

                case 6:
                  if ((_step = _iterator.n()).done) {
                    _context.next = 26;
                    break;
                  }

                  extension = _step.value;
                  _context.t0 = typeof extension;
                  _context.next = _context.t0 === 'function' ? 11 : _context.t0 === 'object' ? 16 : 22;
                  break;

                case 11:
                  extension = extension;
                  _context.next = 14;
                  return extension(method, params);

                case 14:
                  result = _context.sent;
                  return _context.abrupt("break", 22);

                case 16:
                  extension = extension;

                  if (!(extension && extension.extendProvider)) {
                    _context.next = 21;
                    break;
                  }

                  _context.next = 20;
                  return extension.extendProvider(method, params);

                case 20:
                  result = _context.sent;

                case 21:
                  return _context.abrupt("break", 22);

                case 22:
                  if (!result) {
                    _context.next = 24;
                    break;
                  }

                  return _context.abrupt("break", 26);

                case 24:
                  _context.next = 6;
                  break;

                case 26:
                  _context.next = 31;
                  break;

                case 28:
                  _context.prev = 28;
                  _context.t1 = _context["catch"](4);

                  _iterator.e(_context.t1);

                case 31:
                  _context.prev = 31;

                  _iterator.f();

                  return _context.finish(31);

                case 34:
                  if (!result) {
                    _context.next = 37;
                    break;
                  }

                  callback(null, {
                    jsonrpc: jsonrpc,
                    id: id,
                    result: result
                  });
                  return _context.abrupt("return");

                case 37:
                  this.innerProvider.send(request, callback);
                  _context.next = 43;
                  break;

                case 40:
                  _context.prev = 40;
                  _context.t2 = _context["catch"](0);
                  callback(_context.t2);

                case 43:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[0, 40], [4, 28, 31, 34]]);
        }));
      })().catch(function () {
        return null;
      });
    }
  }, {
    key: "sendAsync",
    value: function sendAsync(request) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.send(request, function (err, response) {
          if (err) {
            reject(err);
          } else {
            var error = response.error;

            if (error) {
              reject(error);
            } else {
              resolve(response);
            }
          }
        });
      });
    }
  }, {
    key: "connected$",
    get: function get() {
      return this.innerProvider.connected$;
    }
  }, {
    key: "notification$",
    get: function get() {
      return this.innerProvider.notification$;
    }
  }, {
    key: "innerProvider",
    set: function set(innerProvider) {
      this.currentProvider = innerProvider;
    },
    get: function get() {
      if (!this.currentProvider) {
        throw new Error('undefined innerProvider');
      }

      return this.currentProvider;
    }
  }]);

  return RootProvider;
}();

exports.RootProvider = RootProvider;